<template>
  <span>
    <v-data-table
      :headers="headers"
      :items="manifest"
      :search="search"
      sort-by="vessel_name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Manage Manifest</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="teal" dark class="mb-2" outlined v-on="on">
                <v-icon left>mdi-import</v-icon>Import Manifest
              </v-btn>

              <v-btn
                class="mx-2"
                fab
                small
                dark
                color="indigo"
                @click="editItem"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }} </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-file-input
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/xml"
                      chips
                      ref="manifest"
                      v-model="manifest_file"
                      show-size
                      counter
                      v-on:change="enableButton"
                      label="Manifest File"
                    ></v-file-input>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  :disabled="disable_button_upload"
                  text
                  @click="importManifest"
                  >Import</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <!--  <v-icon small class="mdi mdi-eye" @click="showCargos(item.id)"></v-icon>
        <v-icon
          small
          class="mdi mdi-border-color"
          @click="editItem(item)"
        ></v-icon> -->
        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <!-- <v-btn dark icon v-on="on">
              <v-icon style="color:#808080;">mdi-dots-vertical</v-icon>
            </v-btn>-->
            <v-btn color="primary" outlined fab x-small dark v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(it, i) in menu_items" :key="i">
              <v-list-item-title
                style="cursor: pointer;"
                @click="menuAction({ name: it.ref, item: item })"
                >{{ it.title }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:item.arrivaldate="{ item }">
        <span>{{ item.arrivaldate | formatShortDate }}</span>
      </template>
      <template v-slot:item.departuredate="{ item }">
        <span>{{ item.departuredate | formatShortDate }}</span>
      </template>
    </v-data-table>

    <v-dialog v-model="dlgEdit" max-width="800px">
      <v-form v-model="valid" ref="manifestForm" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }} ({{ manifestType }})</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-autocomplete
                    v-if="header.type === 'select'"
                    :items="vessels"
                    v-model="editedItem[header.id]"
                    item-text="vessel_name"
                    item-value="v_id"
                    :label="header.text"
                    auto-select-first
                    v-on:change="updateField(editedItem[header.id])"
                    no-data-text="Vessel Not Added"
                    required
                    :rules="[v => !!v || 'Item is required']"
                  ></v-autocomplete>
                  <v-text-field
                    v-if="
                      header.value != 'action' &&
                        header.type != 'dateArrival' &&
                        header.type != 'select' &&
                        header.type != 'dateDeparture'
                    "
                    v-model="editedItem[header.value]"
                    :label="header.text"
                    :disabled="header.disable"
                    required
                    :rules="[v => !!v || 'Item is required']"
                  ></v-text-field>
                  <v-menu
                    v-model="menu"
                    v-if="header.type === 'dateArrival'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="doa"
                        v-if="header.type === 'dateArrival'"
                        :label="header.text"
                        prepend-icon="mdi mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="doa"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close('dlgEdit')"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dlgCargos" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dlgTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <CargoList :manifestID="man_id" />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="close('dlgCargos')"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgProgress" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Importing Manifest, please wait!
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      ref="dlgDepartureDate"
      v-model="modal_departure_date"
      :return-value.sync="date_departure"
      persistent
      width="290px"
    >
      <v-date-picker v-model="date_departure" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal_departure_date = false"
          >Cancel</v-btn
        >
        <v-btn text color="primary" @click="setDeparture()">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </span>
</template>
<script>
//import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
//import { FETCH_MANIFEST } from "@/store/modules/actions.type";
import moment from "moment";
import CargoList from "@/components/CargoListDataTable";
import { EventBus } from "../main";

export default {
  name: "ManifestDataTable",
  components: {
    CargoList
  },
  data: () => ({
    valid: false,
    dialog: false,
    dlgEdit: false,
    dlgCargos: false,
    dlgProgress: false,
    disable_button_upload: true,
    show: false,
    menu: null,
    modal_departure_date: false,
    search: "",
    man_id: null,
    voyagenumber: null,
    manifest_file: null,
    date_departure: new Date().toISOString().substr(0, 10),
    doa: new Date().toISOString().substr(0, 10),
    dod: null,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters"
    },
    menu_items: [
      { title: "view cargoes", ref: "view_cargoes" },
      { title: "edit", ref: "edit" },
      { title: "set departure", ref: "set_departure" }
    ],
    headers: [
      {
        text: "Vessel Name",
        align: "left",
        sortable: false,
        value: "vessel_name",
        id: "vessel_id",
        type: "select"
      },
      {
        text: "Shipping Line",
        value: "shipping_line",
        id: "shipping_line_id",
        disable: true
      },
      {
        text: "Voyage Number",
        value: "voyagenumber",
        required: ["Required"]
      },
      { text: "Arrival Date", value: "arrivaldate", type: "dateArrival" },
      { text: "Departure Date", value: "departuredate", type: "dateDeparture" },
      { text: "Actions", value: "action", sortable: false }
    ],
    vessels: [],
    manifest: [],
    activeTab: null,
    selected_item: [],
    vessel_name: null,
    shipping_line_name: null,
    errorMessage: "",
    formHasError: false,
    editedIndex: -1,
    editedItem: {
      vessel_name: "",
      voyagenumber: "",
      arrivaldate: "",
      departuredate: "",
      shipping_line: "",
      status: ""
    },
    defaultItem: {
      vessel_name: "",
      voyagenumber: "",
      arrivaldate: "",
      departuredate: "",
      shipping_line: "",
      status: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Manifest" : "Edit Manifest";
    },
    manifestType() {
      return this.activeTab.toUpperCase();
    },
    dlgTitle() {
      return (
        "List of Cargoes - " +
        this.vessel_name +
        " - voyage no: " +
        this.voyagenumber
      );
    },
    counterRows() {
      return "100";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dlgEdit(val) {
      if (val)
        this.$store.dispatch("vessels/fetchVessels").then(res => {
          this.vessels = res;
        });
    }
  },

  created() {
    EventBus.$on("selectedManifestTab", tab => {
      this.activeTab = tab;
      if (this.activeTab == "import") {
        this.fetchManifest(1);
      } else {
        this.fetchManifest(0);
      }
    });
  },
  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      // this.$store.dispatch("manifest/fetchManifest").then(res => {
      //   this.manifest = res;
      // });
      if (!this.activeTab) {
        this.activeTab = "import";
      }
      this.fetchManifest(1);
    },
    fetchManifest(type = 1) {
      this.$store
        .dispatch("manifest/fetchManifest", "all?type=" + type)
        .then(res => {
          this.manifest = res;
        });
    },
    updateField(val) {
      this.shipping_line_name = this.vessels.filter(f => f.v_id === val);
      this.editedItem.shipping_line = this.shipping_line_name[0].sline_name;
    },
    enableButton() {
      if (this.manifest_file == "" || null) {
        this.disable_button_upload = true;
        return;
      } else {
        this.disable_button_upload = false;
      }
    },

    editItem(item) {
      this.editedIndex = this.manifest.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (this.editedItem.arrivaldate) {
        this.doa = moment(this.editedItem.arrivaldate).format("YYYY-MM-DD");
      } else {
        this.doa = new Date().toISOString().substr(0, 10);
      }

      this.dlgEdit = true;
    },

    deleteItem(item) {
      const index = this.manifest.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.manifest.splice(index, 1);
    },

    close(e) {
      if (e == "dlgEdit") this.dlgEdit = false;
      else if (e == "dlgCargos") this.dlgCargos = false;
      else this.dialog = false;

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    menuAction(obj) {
      let _id = obj.item.id;
      if (obj.name === "view_cargoes") {
        this.showCargos(_id);
      } else if (obj.name === "edit") {
        this.editItem(obj.item);
      } else {
        this.showDialog(obj.item);
      }
    },

    showCargos(item) {
      (this.dlgCargos = true), (this.man_id = item);
      let man = this.manifest.filter(f => f.id === item);
      this.voyagenumber = man[0].voyagenumber;
      this.vessel_name = man[0].vessel_name;
      // console.log("to show all cargos for that manifest --- " + item);
    },
    showDialog(item) {
      if (item) {
        this.selected_item = item;
      } else {
        return;
      }
      this.modal_departure_date = true;
    },

    setDeparture() {
      //console.log("departure set " + this.selected_item.id);
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, set!"
        })
        .then(result => {
          if (result.value) {
            this.modal_departure_date = false;

            //console.log(moment(String(this.date_departure)).format("l"));
            this.$store
              .dispatch("manifest/setDepartureDate", {
                id: this.selected_item.id,
                item: {
                  departuredate: moment(String(this.date_departure)).format("l")
                }
              })
              .then(res => {
                if (res.success) {
                  this.$swal.fire("Date Set!", res.success, "success");
                  this.initialize();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: res.error
                  });
                  return;
                }
              });
          }
        });
    },
    importManifest() {
      this.dlgProgress = true;
      let formData = new FormData();
      formData.append("manifest_file", this.manifest_file);
      // console.log(formData)

      if (formData) {
        this.$store
          .dispatch("manifest/importManifest", this.manifest_file)
          .then(res => {
            if (res.success) {
              this.exit();
              this.initialize();
              this.$noty.success(res.success);
            } else {
              this.$noty.warning(res.error);
              this.exit();
              return;
            }
          });
      }

      // setTimeout(
      // () => ((this.dlgProgress = false), (this.dialog = false)),
      // 3000
      // );
    },
    exit() {
      (this.dlgProgress = false),
        (this.dialog = false),
        (this.manifest_file = null);
    },
    returnManifestType(type) {
      return type == "import" ? 1 : 0;
    },
    save() {
      if (this.editedIndex > -1) {
        //Object.assign(this.manifest[this.editedIndex], this.editedItem);
        if (this.$refs.manifestForm.validate()) {
          let data = {
            id: this.editedItem.id,
            vessel_id: this.editedItem.vessel_id,
            voyagenumber: this.editedItem.voyagenumber,
            arrivaldate: moment(String(this.doa)).format("l"),
            departuredate: null,
            status: 0
          };

          this.$store.dispatch("manifest/updateManifest", data).then(res => {
            if (res.success) {
              this.initialize();
              this.$noty.success(res.success);
            } else this.$noty.warning(res.error);
            return;
          });
        } else {
          return;
        }
      } else {
        if (this.$refs.manifestForm.validate()) {
          let data = {
            vessel_id: this.editedItem.vessel_id,
            voyagenumber: this.editedItem.voyagenumber,
            arrivaldate: this.doa,
            //departuredate: this.dod,
            type: this.returnManifestType(this.activeTab),
            status: 0
          };

          this.$store.dispatch("manifest/saveManifest", data).then(res => {
            if (res.success) {
              this.initialize();
              this.$noty.success(res.success);
            } else {
              this.$noty.warning(res.error);
              return;
            }
          });
        } else {
          return;
        }
      }
      this.close("dlgEdit");
    }
  }
};
</script>
